import utmHandler from '../lib/utmHandler'
class Forms {
  constructor (prefix) {
    this.prefix = prefix
  }

  init () {
    const prefix = this.prefix
    const form = document.querySelector(prefix)

    if (form === null) {
      return
    }

    const section = document.querySelector(`${prefix}`)
    const submitButton = document.querySelector(`${prefix}__submit`)
    const privacyButton = document.querySelector(`${prefix}__privacy`)

    if (section && submitButton && privacyButton) {
      privacyButton.addEventListener('change', () => {
        submitButton.disabled = !privacyButton.checked
      })

      submitButton.disabled = !privacyButton.checked
    }

    form.addEventListener('submit', (e) => {
      e.preventDefault()
      const utmParams = utmHandler.getUtmParams(); // eslint-disable-line

      const fields = {
        name: e.target.elements.name,
        phone: e.target.elements.phone,
        email: e.target.elements.email,
        zip: e.target.elements.zip,
        course_type: e.target.elements.course_type || null,
        course: e.target.elements.course || null,
        product: e.target.elements.product || null,
        privacity: e.target.elements.privacity,
        // ads: e.target.elements.ads,
        form_id: e.target.elements.form_id
      }

      const validation = this.validateFields(fields)
      const data = { ...fields, ...utmParams }

      const onSuccess = () => {
        return this.showSuccess(section)
      }

      if (validation.validated) {
        this.showLoading(section)
        this.postForm(data, onSuccess)
      }
    })
  }

  loadScript () {
    if (window.recaptcha === undefined) {
      const script = document.createElement('script')
      script.setAttribute(
        'src',
        'https://www.google.com/recaptcha/api.js?render=' +
          scripts_ajax_variables.recaptcha_public //eslint-disable-line
      )
      script.async = true
      script.defer = true
      document.getElementsByTagName('head')[0].appendChild(script)
    }
  }

  getFields (form) {
    return {
      name: form.querySelector('input[name=name]'),
      phone: form.querySelector('input[name=phone]'),
      email: form.querySelector('input[name=email]'),
      zip: form.querySelector('input[name=zip]'),
      course_type: form.querySelector('input[name=course_type]') || null,
      course: form.querySelector('input[name=course]') || null,
      product: form.querySelector('input[name=product]') || null,
      privacity: form.querySelector('input[name=privacity]'),
      // ads: form.querySelector('input[name=ads]'),
      form_id: form.querySelector('input[name=form_id]')
    }
  }

  validateFields (fields) {
    const errors = {}
    const nameNode = fields.name.closest('div')
    const phoneNode = fields.phone.closest('div')
    const emailNode = fields.email.closest('div')
    const zipNode = fields.zip.closest('div')
    const tcourseNode = fields.course_type ? fields.course_type.closest('div') : null
    const courseNode = fields.course ? fields.course.closest('div') : null
    const productNode = fields.product ? fields.product.closest('div') : null

    errors.validated = true
    nameNode.classList.remove('hasError')
    phoneNode.classList.remove('hasError')
    emailNode.classList.remove('hasError')
    zipNode.classList.remove('hasError')

    if (tcourseNode) tcourseNode.classList.remove('hasError')
    if (courseNode) courseNode.classList.remove('hasError')
    if (productNode) productNode.classList.remove('hasError')

    if (!fields.name.value) {
      errors.validated = false
      nameNode.classList.add('hasError')
    }

    if (!fields.phone.value) {
      errors.validated = false
      phoneNode.classList.add('hasError')
    }

    if (!fields.email.value) {
      errors.validated = false
      emailNode.classList.add('hasError')
    }

    if (!fields.zip.value) {
      errors.validated = false
      zipNode.classList.add('hasError')
    }

    if (fields.course_type) {
      if (fields.course_type.value === '0') {
        errors.validated = false
        tcourseNode.classList.add('hasError')

        let errorMsg = tcourseNode.querySelector('.error-message')
        if (!errorMsg) {
          errorMsg = document.createElement('div')
          errorMsg.classList.add('error-message')
          errorMsg.textContent = 'Por favor, selecciona un tipo de curso.'
          errorMsg.style.color = 'red'
          errorMsg.style.fontSize = '14px'
          errorMsg.style.marginTop = '5px'
          errorMsg.style.marginBottom = '10px'
          tcourseNode.appendChild(errorMsg)
        }
      } else {
        const errorMsg = tcourseNode.querySelector('.error-message')
        if (errorMsg) {
          errorMsg.remove()
        }
      }
    }

    if (fields.course) {
      if (fields.course.value === '0') {
        errors.validated = false
        courseNode.classList.add('hasError')

        let errorMsg = courseNode.querySelector('.error-message')
        if (!errorMsg) {
          errorMsg = document.createElement('div')
          errorMsg.classList.add('error-message')
          errorMsg.textContent = 'Por favor, selecciona un curso.'
          errorMsg.style.color = 'red'
          errorMsg.style.fontSize = '14px'
          errorMsg.style.marginTop = '5px'
          errorMsg.style.marginBottom = '10px'
          courseNode.appendChild(errorMsg)
        }
      } else {
        const errorMsg = courseNode.querySelector('.error-message')
        if (errorMsg) {
          errorMsg.remove()
        }
      }
    }

    if (fields.product) {
      if (fields.product.value === '0') {
        errors.validated = false
        productNode.classList.add('hasError')

        let errorMsg = productNode.querySelector('.error-message')
        if (!errorMsg) {
          errorMsg = document.createElement('div')
          errorMsg.classList.add('error-message')
          errorMsg.textContent = 'Por favor, selecciona una opcion.'
          errorMsg.style.color = 'red'
          errorMsg.style.fontSize = '14px'
          errorMsg.style.marginTop = '5px'
          errorMsg.style.marginBottom = '10px'
          productNode.appendChild(errorMsg)
        }
      } else {
        const errorMsg = productNode.querySelector('.error-message')
        if (errorMsg) {
          errorMsg.remove()
        }
      }
    }

    return errors
  }

  postForm (data, onSuccess) {
    const action = 'send_form'
    // Recaptcha validation
    // eslint-disable-next-line
    grecaptcha.ready(function () {
      grecaptcha // eslint-disable-line
        .execute(scripts_ajax_variables.recaptcha_public, { action: action }) // eslint-disable-line
        .then(function (token) {
          // eslint-disable-line
          var xmlhttp = window.ajaxReq()
          var url = encodeURI(scripts_ajax_variables.ajax_url); // eslint-disable-line
          var params = 'action=' + action
          params += '&formFromUrl=' + window.location.pathname
          params += '&form_id=' + data.form_id.value
          params += '&name=' + data.name.value
          params += '&email=' + data.email.value
          params += '&phone=' + data.phone.value
          params += '&zip=' + data.zip.value
          params += '&course_type=' + (data.course_type ? data.course_type.value : '')
          params += '&course=' + (data.course ? data.course.value : '')
          params += '&product=' + (data.product ? data.product.value : '')
          params += '&privacity=' + data.privacity.checked
          // params += '&ads=' + data.ads.checked
          params += '&campaignId=' + data.utm_id
          params += '&campaignSource=' + data.utm_source
          params += '&campaignMedium=' + data.utm_medium
          params += '&campaignCampaign=' + data.utm_campaign
          params += '&campaignTerms=' + data.utm_term
          params += '&campaignContent=' + data.utm_content
          params += '&campaignUser=' + data.utm_user
          params += '&campaignReferer=' + data.utm_referrer
          params += '&pageName=' + document.title
          params += "&nonce=" + scripts_ajax_variables.nonce; // eslint-disable-line
          params += "&token=" + token; // eslint-disable-line
          params = params.replaceAll('=null&', '=&')
          xmlhttp.open('POST', url, true) // set true for async, false for sync request
          xmlhttp.setRequestHeader(
            'Content-type',
            'application/x-www-form-urlencoded'
          )
          xmlhttp.send(params) // or null, if no parameters are passed

          xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
              console.log(xmlhttp.readyState)
              console.log(xmlhttp.status)
              try {
                console.log(xmlhttp.responseText)
                var data = JSON.parse(xmlhttp.responseText)
                console.log(xmlhttp.responseText)
                console.log(data)
                if (data.status === 'success') {
                  onSuccess()
                }
              } catch (error) {
                console.log(error)
              }
            }
          }
        })
    })
  }

  showLoading (section) {
    const prefix = this.prefix
    section.querySelector(`${prefix}__form`).classList.add('isHidden')
    section.querySelector(`${prefix}__title`).classList.add('isHidden')
    section.querySelector(`${prefix}__description`).classList.add('isHidden')
    section
      .querySelector(`${prefix}__loading`)
      .classList.remove('isHidden')
  }

  showSuccess (section) {
    const prefix = this.prefix
    const idform = document.querySelector(prefix).getElementsByTagName('form')[0].id
    section.querySelector(`${prefix}__loading`).classList.add('isHidden')
    section
      .querySelector(`${prefix}__success`)
      .classList.remove('isHidden')
    window.dataLayer.push({
      event: idform,
      user_data: {
        email_address: document.querySelector('#' + idform + ' ' + 'input[name=email]').value,
        phone_number: document.querySelector('#' + idform + ' ' + 'input[name=phone]').value
      }
    })
    // eslint-disable-next-line
    gtag('event', 'lead', { event_category: 'formulario', event_label: 'contactform' })
  }
}

export default Forms
